<template>
  <CRow>
    <CCol lg="6">
      <CInput
        v-model="form.benefit"
        label="Benefício*"
        placeholder="Benefício"
        :disabled="processing"
        class="mb-1"
      />
    </CCol>
    <CCol lg="6">
      <label :for="`benefitIcon${index}`">Ícone</label>
      <Multiselect
        :id="`benefitIcon${index}`"
        :value="selectedIcon"
        :options="icons"
        @select="({ value }) => (form.icon_id = value)"
        class="cursor-default"
      />
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from '@/components/ui/Multiselect'
import formFragmentMixin from '@/mixin/form-fragment'

export default {
  mixins: [formFragmentMixin],
  components: { Multiselect },
  props: {
    processing: { type: Boolean, required: true },
    icons: { type: Array, required: true },
    index: { type: Number, required: true }
  },
  computed: {
    selectedIcon() {
      const icon = this.form.icon_id
      return this.icons.find(({ value }) => value == icon)
    }
  }
}
</script>
